// react
// dependencies
import { List } from "immutable";
import PropTypes from "prop-types";
import React from "react";

// components
import Job from "./Job";

export default class Status extends React.PureComponent {
	static propTypes = {
		onMouseLeave: PropTypes.func.isRequired,
		onMouseEnter: PropTypes.func.isRequired,
		jobs: PropTypes.instanceOf(List).isRequired,
	};

	static defaultProps = {};

	state = {};

	render() {
		const { jobs } = this.props;

		return (
			<div
				className="jobs-list-wrapper"
				onMouseLeave={this.props.onMouseLeave}
				onMouseEnter={this.props.onMouseEnter}
			>
				<div className="jobs-list">
					{jobs.map((job) => (
						<Job key={job.get("task_id")} job={job} />
					))}
				</div>
			</div>
		);
	}
}
